export default "/assets/9526470852428b4340ed994462821463.woff2";